// Matomo tracker helpers.
//
// The tracker snippet in util/includeScripts.js defines the window._paq command
// queue synchronously in <head>, so commands pushed before matomo.js has loaded
// are replayed once it is ready. Outside the browser every helper is a no-op.

export const matomoPush = (...command) => {
  if (typeof window !== 'undefined' && window._paq) {
    window._paq.push(command);
  }
};

// Feeds Matomo's Site Search reports (Keywords, Categories, "No Result Keywords").
// https://developer.matomo.org/guides/tracking-javascript-guide#internal-search-tracking
export const trackSiteSearch = (keyword, category, resultCount) =>
  matomoPush('trackSiteSearch', keyword, category, resultCount);
